export const SET_GLOWFORGE_PRODUCT_LIST = 'SET_GLOWFORGE_PRODUCT_LIST';
export const SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';
export const SET_CONFIRMATION_PAGE = 'SET_CONFIRMATION_PAGE';



// WEBPACK FOOTER //
// ./app/store/actions/glowforge-store.js